
import { supabase } from '@/lib/supabase';
import { ReferrerStat } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

export const getReferrerStats = async (
  startDate: Date,
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<ReferrerStat[]> => {
  try {
    const { data, error } = await supabase.rpc('get_referrer_stats_aggregated', {
      start_date: startDate.toISOString(),
      end_date: endDate.toISOString(),
      auth_filter: authFilter
    });

    if (error) {
      console.error('Error fetching referrer stats:', error);
      throw error;
    }

    if (!data || data.length === 0) {
      return [];
    }

    // Database function now returns user-friendly names, no post-processing needed
    return data.map(item => ({
      referrer_category: item.referrer,
      count: Number(item.count)
    }));

  } catch (error) {
    console.error('Error in getReferrerStats:', error);
    throw error;
  }
};
